import "./WorkCard.scss";
import BorderCircle from "../BorderCircle/BorderCircle";
import Icon from "../Icon/Icon";

const WorkCard = ({
  title,
  description,
  avatar,
  avatarWebp,
  index,
  images,
  imagesWebp,
  build,
  code,
}) => {
  return (
    <div className="work-card">
      <div className="work-card__content">
        <h2 className="work-card__title">{title}</h2>
        <p className="work-card__description">{description}</p>
      </div>

      {avatar && (
        <a
          href={images[0]}
          data-fancybox={`gallery-${index}`}
          className="work-card__link"
        >
          <picture>
            {avatarWebp && (
              <source srcSet={avatarWebp} type="image/webp"></source>
            )}
            <img
              className="work-card__img"
              src={avatar}
              alt={title}
              loading="lazy"
            />
          </picture>

          <Icon
            className="work-card__link-icon"
            id="icon-loop"
            width="180"
            height="180"
          />
        </a>
      )}

      {/* остальные изображения — "невидимые" ссылки */}
      {images.slice(1).map((img, i) => {
        const webp = imagesWebp?.[i + 1]; // сдвиг на 1, потому что первый — avatar
        return (
          <a
            href={img}
            data-fancybox={`gallery-${index}`}
            key={i}
            style={{ display: "none" }}
          >
            <picture>
              {webp && <source srcSet={webp} type="image/webp" />}
              <img src={img} alt={`${title} ${i + 2}`} loading="lazy"/>
            </picture>
          </a>
        );
      })}

      <div className="work-card__buttons">
        {build && (
          <a
            href={build}
            target="_blank"
            rel="noreferrer"
            className="btn work-card__btn"
          >
            {/* Посетить сайт */}
            Посетить
          </a>
        )}
        {code && (
          <a
            href={code}
            target="_blank"
            rel="noreferrer"
            className="btn work-card__btn"
          >
            Посмотреть код
          </a>
        )}

        {!build && !code && (
          <BorderCircle className="center">
            <span className="work-card__empty">Скоро будет доступно</span>
          </BorderCircle>
        )}
      </div>
    </div>
  );
};

export default WorkCard;
